import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "move_to",
  "use": "move_to-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"move_to\"><path d=\"M1 8h11v2l3 3h1v3H1z\" opacity=\".12\" /><path d=\"M1 15h15v1H1z\" opacity=\".12\" /><path d=\"m6 3 2 2h7v1H7.5l-2-2H1v3h11v1H1v8h15v-3h1v2.998C17 16.55 16.545 17 16 17H1c-.552 0-1-.45-1-1.007V4.007C0 3.45.451 3 .99 3H6Zm11 0v6.929L18.688 8H20l-3.5 4L13 8h1.313L16 9.929V3h1Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol